import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { MessageSquare, Send } from "lucide-react";
import { useAiChat } from "@/lib/useAiChat";
import { AiChatMessages } from "@/components/AiChatMessages";

const SUGGESTIONS = [
  "Why did the cost change this period?",
  "Where is most of the electricity going?",
  "Which fault is costing the most and why?",
];

/** Ask questions about this building's own energy, cost and fault figures (admins only). */
export function AiChat({ siteId, start, days }) {
  const { messages, streaming, ask } = useAiChat({ siteId, start, days });
  const [question, setQuestion] = useState("");

  const send = (text) => {
    setQuestion("");
    ask(text);
  };

  return (
    <div className="mt-6 k-card p-6" data-testid="ai-chat">
      <div className="k-label flex items-center gap-2"><MessageSquare className="h-3.5 w-3.5" /> Ask your data</div>
      <p className="mt-1 k-sublabel">Answers come from this building's figures for the selected period.</p>

      {messages.length === 0 && (
        <div className="mt-4 flex flex-wrap gap-2" data-testid="ai-chat-suggestions">
          {SUGGESTIONS.map((s, i) => (
            <button key={s} onClick={() => send(s)} className="k-btn-outline" data-testid={`ai-suggestion-${i}`}>
              {s}
            </button>
          ))}
        </div>
      )}

      <AiChatMessages messages={messages} streaming={streaming} />

      <div className="mt-4 flex gap-2">
        <Input
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send(question)}
          placeholder="Ask about usage, cost, peaks or faults…"
          disabled={streaming}
          data-testid="ai-chat-input"
        />
        <button onClick={() => send(question)} disabled={streaming || !question.trim()} className="k-btn-primary shrink-0" data-testid="ai-chat-send">
          <Send className="h-3 w-3" /> {streaming ? "…" : "Ask"}
        </button>
      </div>
    </div>
  );
}
